import React from "react";
import "./ProjectsCart.css";

import { GithubOutlined } from "@ant-design/icons";

export default function ProjectsCart({
  Img,
  Text1,
  Text2,
  Text3,
  Link1,
  Link2,
}) {
  return (
    <div className="ProjectsCart-Body">
      <div className="ProjectsCart-Box">
        <img src={Img} alt="" className="ProjectsCart-Img" />
      </div>
      <a href={Link1} target="blank" className="ProjectsCart-A-Tag">
        <p className="ProjectsCart-Text1"><samp className="ProjectsCart-Samp">Live-</samp>{Text1}</p>
      </a>
      <div className="ProjectsCart-Div">
        <p style={{opacity:'.6'}}>[{Text2}]</p>
        <a href={Link2} target="blank" className="ProjectsCart-A-Tag">
          <GithubOutlined className="ProjectsCart-Icon"/>
        </a>
      </div>
      <p className="ProjectsCart-Text2">{Text3}</p>
    </div>
  );
}
